import { IconDashboard, IconMap } from '@tabler/icons';

// constant
const icons = {
    IconDashboard,
    IconMap
};

// ==============================|| DASHBOARD PAGE & MENU ITEMS ||============================== //

const other = {
    id: 'main',
    type: 'group',
    children: [
        {
            id: 'rete',
            title: 'NET',
            type: 'item',
            url: '/net',
            icon: icons.IconMap,
            breadcrumbs: false
        },
        {
            id: 'analysis',
            title: 'ANALYSIS',
            type: 'item',
            url: '/analysis',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export default other;
